"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var responsive_util_1 = require("../responsive/responsive-util");
var useSketchValues = function () {
    var isMobile = responsive_util_1.useMobileView();
    var leftBreakPoint = isMobile ? 0 : 0.18;
    var rightBreakPoint = isMobile ? 0 : 0.18;
    return {
        topOffset: 20,
        dashLength: 8,
        leftBreakPoint: leftBreakPoint,
        rightBreakPoint: rightBreakPoint,
        middleDistance: 1 - leftBreakPoint - rightBreakPoint,
    };
};
exports.default = useSketchValues;
//# sourceMappingURL=installation-sketch-constants.hook.js.map